import { Card, Col, Row, Skeleton,Breadcrumb } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import TopHeader from "../../../components/topHeader/view";
import * as loginActions from "./../actions";
import "./dashboard.css";
import GenTable from './genTable';
import { Link } from "react-router-dom";
const queryString = require('query-string');

class toppComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      category:"Student",
      campus:null
    };
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  componentWillMount() {
    var parsed = queryString.parse(this.props.location.search);

   

    if(parsed.Campus && parsed.Campus!='null'){
      this.setState({campus:parsed.Campus})
    }

    if(parsed && parsed.Category&& parsed.Category.length>0 && (parsed.Category=="Student" || parsed.Category=="Faculty")){
      this.props.loadFacultyList();
      this.setState({ category:parsed.Category});
    }
    else{
      this.props.loadFacultyList();
      this.setState({ category:"Student"});
    }
  
    
  }

  render() {
    
    const loading  = this.props.skeltonLoading ? this.props.skeltonLoading.show : true;
    const hodList  =  this.props.hodList && Object.entries(this.props.hodList).length != 0 && (this.props.hodList).constructor === Object ? this.props.hodList : null
    
    return (
      <>
        <TopHeader
          title={"Faculty List"}
        />
        <Row type="flex" justify="center"  >
  <Col xs={20} sm={20} md={8} lg={8} xl={8} style={{textAlign:'center', background:'white',marginTop:'-25px',borderRadius:'0.5rem', boxShadow:'0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'}}>
  {this.state.category && this.state.category=="Student" ? 
  <>
  <Link  to={"/home/studentsList?Category=Student&Campus="+this.state.campus}><Col id="topHeaderHighlightleft" span={12} style={{padding:12,color:'#6025C0',cursor:'pointer',boxShadow:'inset 0 11px 47px 0 rgba(0, 0, 0, 0.15)',background:'rgb(236, 234, 234)',borderTopLeftRadius:'0.5rem',borderBottomLeftRadius:'0.5rem',fontWeight:500}} >Students</Col></Link>
  <Link to={"/home/facultyList?Category=Faculty&Campus="+this.state.campus}><Col id="topHeaderHighlightright" span={12} style={{padding:12,color:'#000000', borderTopRightRadius:'0.5rem',cursor:'pointer',borderBottomRightRadius:'0.5rem',fontWeight:500}}>Faculty</Col></Link>
  </> : <>
  <Link  to={"/home/studentsList?Category=Student&Campus="+this.state.campus}><Col id="topHeaderHighlightright" span={12} style={{padding:12,color:'#000000',cursor:'pointer',borderTopLeftRadius:'0.5rem',borderBottomLeftRadius:'0.5rem',fontWeight:500}} >Students</Col></Link>
  <Link to={"/home/facultyList?Category=Faculty&Campus="+this.state.campus}><Col id="topHeaderHighlightleft" span={12} style={{padding:12,color:'#6025C0', borderTopRightRadius:'0.5rem',cursor:'pointer',borderBottomRightRadius:'0.5rem',fontWeight:500,background:'rgb(236, 234, 234)'}}>Faculty</Col></Link>
  </>}
  
  </Col>
  </Row>

    <Row gutter={16} style={{ padding: 33, matginTop: 30 }}>
    <Breadcrumb style={{paddingLeft:10,paddingBottom:30}}>
    <Breadcrumb.Item> <Link to={"/home/campusDashboard/ADMIN?Category="+(this.state.category && this.state.category)}>Society Dashboard</Link> </Breadcrumb.Item>
    {this.state.campus && <Breadcrumb.Item>
    <Link to={"/home/campusDashboard/"+this.state.campus+"?Category="+(this.state.category && this.state.category)}> {(this.state.campus).toUpperCase()}</Link>
    </Breadcrumb.Item>}
    <Breadcrumb.Item>
    Registred Faculty
    </Breadcrumb.Item>
    </Breadcrumb>
          <Col>
            <Card title="List of Faculty/HOD/Principal" bordered={false}>
              
              <Skeleton active={loading} loading={loading}>

               {hodList ? <GenTable branch={this.props.userBranch} campus={this.props.userCampus} props={this.props} data={hodList.data}/> :null}             
              </Skeleton>
            </Card>
          </Col>
        </Row>

      </>
    )
  }
}

const mapStateToProps = state => {
  
  
  return {
    hodList: state.auth.hodList,
    skeltonLoading: state.loading
  };
};

const mapDispachToProps = (dispatch, props) => ({
  loadFacultyList: () => {
    dispatch(loginActions.loadFacultyList());
  },
  onUnload: () =>
    dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(toppComponent);
